const STORAGE_KEY = "homecare_life_attribution";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

const hasNewSignal = (params, referrer) => {
  if (params.get("gclid") || params.get("fbclid")) return true;
  if (UTM_KEYS.some((key) => params.get(key))) return true;
  if (referrer && !referrer.includes(window.location.hostname)) return true;
  return false;
};

export const captureAttribution = () => {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const { referrer } = document;

  if (!hasNewSignal(params, referrer)) return;

  const attribution = {
    referrer: referrer || "",
    gclid: params.get("gclid") || "",
    fbclid: params.get("fbclid") || "",
  };

  UTM_KEYS.forEach((key) => {
    attribution[key] = params.get(key) || "";
  });

  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
};

export const getAttribution = () => {
  if (typeof window === "undefined") return {};

  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};
